<template>
  <v-app :class="fontLoaded === true ? '' : 'font-not-loaded' ">

    <offline @detected-condition="handleConnectivityChange"></offline>

    <span class="cogneti-logo hidden-sm-and-down">
        <img height="26" src="@/assets/logos/cogneti.svg" alt="Cogneti"></span>

    <v-content class="sfh-container"  >
      <v-container fluid fill-height style="padding:0!important;">
        <v-layout align-center justify-center :style="styleObjectLayout" class="text-xs-left"  >
          <v-flex xs12 sm8  elevation-10 :style="styleObject" >
            <v-flex class="gutter-mobile-header" style="background:#4a2dff;" />
            <router-view v-title="$route.meta.title" />
          </v-flex>
        </v-layout>
      </v-container>

    </v-content>

        <v-snackbar
          :timeout="timeout"
          :color="color"
          :multi-line="mode === 'multi-line'"
          :vertical="mode === 'vertical'"
          :bottom="true"
          :right="true"
          v-model="snackbar"
        >
          <v-layout align-center>
            <div class="snack-markdown" v-html="text"></div>
            <div class="spacer"></div>
            <v-btn flat icon @click.native="snackbar = false">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-layout>
        </v-snackbar>

        <v-dialog
          v-model="loadingDialog"
          hide-overlay
          persistent
          width="300"
        >
          <v-card
            color="primary"
            dark
          >
            <v-card-text>
              Loading&hellip;
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

    <v-tour name="dashboardTour" :callbacks="myCallbacks" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template >
              <!--<div slot="actions">-->
                <!--<button @click="tour.stop" class="btn btn-primary">Skip Tour</button>-->
                <!--<button v-if="tour.isFirst === false" @click="tour.previousStep" class="btn btn-primary">-->
                  <!--Previous-->
                <!--</button>-->
                <!--<button v-if="tour.isLast === false" @click="tour.nextStep" class="btn btn-primary">-->
                  <!--Next-->
                <!--</button>-->
              <!--</div>-->
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>

    <div id="overlay" :class="currentStep === -1?'d-none':'d-block'"></div>

    <v-dialog v-model="settingsDrawer"
      v-if="settingsDrawer"
      fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="settingsDrawer = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="settingsDrawer = false">Close</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <SettingsBody onlyProfile="yes"/>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog v-model="allNewsDialog"  fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>
            <font-awesome-icon
              class="ml-1 left"
              :icon="['fas', 'newspaper']"
              style="margin-top:6px;" />&nbsp;
            Food Safety News</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="allNewsDialog = false">
              <v-icon>close</v-icon></v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="scrollbar scroll-style-15" >
          <v-expansion-panel >

            <v-expansion-panel-content
              v-for="(rssItem, index) in $store.getters['getRssFeed'].slice(0, 5)"
              :key="index"
              expand-icon="expand_more" class="grey lighten-3" :class="index > 0 ? 'mt-2' : ''">
              <div slot="header">
                {{rssItem.title}}&nbsp;&mdash;&nbsp;
                <span class="grey--text text--lighten-0">{{ rssItem.pubDate | moment("MMMM Do YYYY") }}</span>
              </div>
              <v-card class="scrollbar scroll-style-5" style="max-height:250px;">
                <v-card-text class="pl-4" >
                  <div v-html="rssItem.content"></div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>

          </v-expansion-panel>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>

        <v-card-actions class="grey lighten-2" style="
          position: absolute;
          bottom: 0;
          width: 100%;">
          <v-layout column>
            <v-flex px-2 pb-2 grey--text text--darken-2 text-xs-center>
              Knowledge of current food safety news is part of good training!
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newsDialog"  persistent :width="$store.getters.getAppWidth - 10" >
      <v-card v-if="$store.getters['getRssFeed'].length !== 0">
        <v-card-title class="pl-3 pr-1 py-0 title primary white--text font-weight-regular">
          Food Safety News
          <v-spacer></v-spacer>
          <v-btn fab dark flat color="white" style="height:40px;width:40px;" @click="newsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="scrollbar scroll-style-15" style="max-height:400px;">
          <v-flex pb-2>
            <span class="title font-weight-light">{{$store.getters['getRssFeed'][0].title}}&nbsp;</span>&mdash;&nbsp;
            <span class="grey--text text--lighten-0">{{ $store.getters['getRssFeed'][0].pubDate | moment("MMMM Do YYYY") }}</span>
          </v-flex>
          <v-flex class="text-xs-justify" v-html="$store.getters['getRssFeed'][0].content"></v-flex>
        </v-card-text>
        <v-card-actions class="grey lighten-2">
          <v-layout column>
            <v-flex px-2 pb-2 grey--text text--darken-2 text-xs-center>
              Knowledge of current food safety news is part of good training!
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  import Header from './components/layouts/Header'
  import offline from 'v-offline'
  import Vue from 'vue'
  import VueTour from 'vue-tour'
  import SettingsBody from './components/views/auth/SettingsBody'
  import { StatusBar, Style } from '@capacitor/status-bar'
  import { Keyboard } from '@capacitor/keyboard'
  import { IdleTimer } from './idletime'

  require('vue-tour/dist/vue-tour.css')
  Vue.use(VueTour)

  function getCookie (cname) {
    var name = cname + '='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }

  function getOS () {
    let userAgent = window.navigator.userAgent
    let platform = window.navigator.platform
    let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
    let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
    let iosPlatforms = ['iPhone', 'iPad', 'iPod']
    let os = 'Desktop'
    // Initially following code return Different OS but for now it will return only iOS, Android and Desktop
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'DESKTOP'
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'IOS'
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'DESKTOP'
    } else if (/Android/.test(userAgent)) {
      os = 'ANDROID'
    } else if (!os && /Linux/.test(platform)) {
      os = 'DESKTOP'
    }
    return os
  }

  const MAX_LEVEL = process.env.GAME_LEVELS
  const MAX_LEVEL_TEXT = process.env.GAME_LEVELS_TXT

  export default {
    components: {SettingsBody, Header, offline},
    data () {
      return {
        timeOut: 2 * 60 * 1000,
        sendDataTimeout: 2 * 60 * 1000,
        sendDataTimestamp: Date.now(),
        sleepTime: Date.now(),
        fixed: false,
        mode: '',
        sat: 0,
        sab: 0,
        innerHeight: 0,
        windowInnerHeight: 0,
        timeout: 6000,
        fontLoaded: false,
        apiUrl: process.env.API_URL,
        siteUrl: process.env.SITE_URL,
        env: process.env.NODE_ENV,
        onlineStatus: false,
        links: [
          {name: 'CertificateProgram', text: 'Certificate program'},
          {name: 'Faq', text: 'Faq'},
          {name: 'PrivacyPolicy', text: 'Privacy policy'},
          {name: 'TermsOfUse', text: 'Terms of use'},
          {name: 'AnsiAccreditation', text: 'Ansi Accreditation'}
        ],
        steps: [
          {
            target: '.layout.level-row:nth-child(' + MAX_LEVEL + ') .learn-bar',
            content: `Start with a tap here.<br> You'll see the first level of course subjects.<br><br>You'll earn COINS by reading subject pages.`,
            params: {
              placement: 'top'
            }
          }, {
            target: '.layout.level-row:nth-child(' + MAX_LEVEL + ') .quiz-icon',
            content: 'Or just start with a quiz!<br><br> Each quiz has a unique set of 10 questions.',
            params: {
              placement: 'top'
            }
          }, {
            target: '.layout.level-row:nth-child(' + MAX_LEVEL + ') .quiz-tour',
            content: 'In a quiz, use coins to PEEK at a course page where the answer is found!<br><br>Peeks enable fast learning',
            params: {
              placement: 'top'
            }
          }, {
            target: '.layout.level-row:nth-child(' + MAX_LEVEL + ') .progress-tour',
            content: 'Use quizzes to build your skill from beginner to expert!<br><br>Your goal is to be expert on all ' + MAX_LEVEL_TEXT + ' levels.',
            params: {
              placement: 'top'
            }
          }, {
            target: '.layout.level-row:nth-child(' + MAX_LEVEL + ') .progress-icon',
            content: 'Tap here to show your skill on each level.<ol class="sfh-course-levels"><li>Beginner</li><li>Advanced</li><li>Expert</li></ol>',
            params: {
              placement: 'top'
            }
          }, {
            target: '#examBtnId',
            content: `Use the quiz at least once on all ${MAX_LEVEL_TEXT} course levels to enable the exam.`
          }, {
            target: '.exam-btn',
            content: 'When you pass the exam, you are badged as course-complete.<br><br> That is a big deal.',
            params: {
              placement: 'bottom'
            }
          }, {
            target: '#cogenti-sfh-logo',
            content: 'Look to the app menu for support, settings and to show the tour again!',
            params: {
              placement: 'bottom'
            }
          }],
        myCallbacks: {
          onStart: this.tourOnStartCallback,
          onPreviousStep: this.tourPreviousStepCallback,
          onNextStep: this.tourNextStepCallback,
          onStop: this.tourStopCallback
        },
        currentStep: -1
      }
    },
    name: 'App',
    mounted: function () {
      const timeOut = (getOS() === 'IOS' || getOS() === 'ANDROID') ? 500 : 1
      setTimeout(() => {
        this.onResize()
      }, timeOut)

      if (getOS() === 'IOS' || getOS() === 'ANDROID') {
        this.setStatusBarStyleLight()
      }
      // console.log('idleTimer.active', idleTimer.active)
    },

    beforeMount () {
      if (getOS() === 'IOS' || getOS() === 'ANDROID') {
        Keyboard.addListener('keyboardDidShow', () => {
          this.$store.commit('setMobileStatusBarStatus', false)
        })

        Keyboard.addListener('keyboardDidHide', () => {
          this.$store.commit('setMobileStatusBarStatus', true)
        })
      }
    },
    computed: {
      tracking: {
        get: function () {
          return this.$store.getters['user/getTracking']
        },
        set: function (newValue) {
          this.$store.commit('user/setTracking', newValue)
        }
      },
      appHeight: {
        get: function () {
          return this.$store.getters.getAppHeight
        },
        set: function (newValue) {
          this.$store.commit('setAppHeight', newValue)
        }
      },
      appWidth: {
        get: function () {
          return this.$store.getters.getAppWidth
        },
        set: function (newValue) {
          this.$store.commit('setAppWidth', newValue)
        }
      },
      styleObjectLayout () {
        const isXs = this.$vuetify.breakpoint.name === 'xs'
        const height = isXs ? 'inherit' : this.appHeight + 'px'
        return {
          'min-height': height
        }
      },
      styleObject: {
        get: function () {
          const isXs = this.$vuetify.breakpoint.name === 'xs'
          const height = this.appHeight > 600 ? this.appHeight + 'px' : '100%'
          return {
            'max-width': this.appWidth + 'px',
            'height': isXs ? '100%' : height,
            'min-height': isXs ? 'inherit' : this.appHeight + 'px',
            'border-radius': '10px'
          }
        }
      },
      newsDialog: {
        get: function () {
          return this.$store.getters['getNewsDialog']
        },
        set: function (newValue) {
          this.$store.commit('setNewsDialog', newValue)
        }
      },
      allNewsDialog: {
        get: function () {
          return this.$store.getters['getAllNewsDialog']
        },
        set: function (newValue) {
          this.$store.commit('setAllNewsDialog', newValue)
        }
      },
      tourVal: {
        get: function () {
          return this.$route.query.tour
        }
      },
      loadingDialog: {
        get: function () {
          return this.$store.getters.getLoadingDialog
        }
      },
      loadingCourseDialog: {
        get: function () {
          return this.$store.getters.getLoadingCourseDialog
        }
      },
      settingsDrawer: {
        get: function () {
          return this.$store.getters.getSettingsDrawer
        },
        set: function (newValue) {
          this.$store.commit('setSettingsDrawer', newValue)
        }
      },
      isDashboardTourStart: {
        get: function () {
          return this.$store.getters.getDashboardTourStart
        },
        set: function (newValue) {
          this.$store.commit('setDashboardTourStart', newValue)
        }
      },
      snackbar: {
        get: function () {
          return this.$store.getters.getSnackBar.display
        },
        set: function (newValue) {
          this.$store.commit('hideSnackBar')
        }
      },
      color: {
        get: function () {
          return this.$store.getters.getSnackBar.color
        },
        set: function (newValue) {
        }
      },
      text: {
        get: function () {
          return this.$store.getters.getSnackBar.text
        },
        set: function (newValue) {
        }
      },
      badgeScore: function () {
        return this.$store.getters['course/getBadgeScore']
      },
      levelsCount: function () {
        return this.$store.getters['getLevelsCount']
      },
      mobileStatusBarStatus: function () {
        return this.$store.getters['getMobileStatusBarStatus']
      },
      pageRoute: function () {
        return this.$route.name
      }
    },

    methods: {
      async setStatusBarStyleLight () {
        await StatusBar.setStyle({ style: Style.Dark })
      },
      onResize () {
        const isXs = this.$vuetify.breakpoint.name === 'xs'
        let innerHeight = window.innerHeight
        const innerWidth = window.innerWidth
        let maxHeight = innerHeight
        let maxWidth = 400
        if (innerHeight > 650 && innerHeight < 800) {
          maxHeight = 630
        } else if (innerHeight > 820 && innerHeight < 1000) {
          maxHeight = 800
          maxWidth = 510
        } else if (innerHeight > 1000) {
          maxHeight = 980
          maxWidth = 625
        } else if (innerHeight < 650) {
          maxHeight = innerHeight - 20
        }

        const sat = window.getComputedStyle(document.documentElement).getPropertyValue('--sat')
        const sab = getComputedStyle(document.body).getPropertyValue('--sab')

        innerHeight -= (parseInt(sat) + parseInt(sab))
        this.sat = sat
        this.sab = sab
        this.innerHeight = innerHeight
        this.windowInnerHeight = window.innerHeight

        this.appHeight = isXs ? (innerHeight) : maxHeight
        this.appWidth = isXs ? (innerWidth) : maxWidth
      },
      me () {
        // console.log('Auth from Route', this.$route.meta.auth)
        localStorage.setItem('default_auth_token', getCookie('auth_token'))
        const GAME_ID = process.env.GAME_ID
        const USER_NAME = getCookie('user_name')
        if (getCookie('user_name') && getCookie('auth_token')) {
          this.$http({
            url: `${this.apiUrl}/ws/playerservice/user/${USER_NAME}?deck=${GAME_ID}`,
            method: 'GET',
            headers: {
              Authorization: 'Bearer ' + getCookie('auth_token')
            }
          }).then((res) => {
            this.$store.commit('setAuthToken', getCookie('auth_token'))
            // console.log('Resonse Data', res.data)
            this.$auth.user(res.data)
            this.$auth.watch.authenticated = true
            document.cookie = 'user_name=' + res.data.friendlyName + ';domain=cogneti.com'
            document.cookie = 'user_email=' + res.data.email + ';domain=cogneti.com'
            this.$store.commit('user/setUserDetails', res.data)
            this.$store.commit('user/setAvatar', res.data.userImageUrl)
            this.$store.commit('user/setFirstName', res.data.firstName)
            this.$store.commit('user/setLastName', res.data.lastName)
            this.$store.commit('user/setUserId', res.data.id)
            this.$store.commit('user/setState', res.data.stateId)
            this.$store.commit('user/setPhone', res.data.phoneNumber)
            this.$store.commit('user/setAddressLine1', res.data.addressLine1)
            this.$store.commit('user/setAddressLine2', res.data.addressLine2)
            this.$store.commit('user/setCity', res.data.city)
            this.$store.commit('user/setPostalCode', res.data.postalCode)
            const countryId = res.data.countryId !== null ? res.data.countryId : 233
            // console.log('countryId', countryId)
            this.$store.commit('user/setCountry', countryId)
            const keyEmail = localStorage.getItem('email')
            if (typeof keyEmail === 'undefined' || keyEmail !== res.data.email) {
              localStorage.setItem('email', res.data.email)
              this.$store.commit('setDashboardTourStart', 0)
              this.$store.commit('setNewUserLoggedin', true)
              // this.$store.commit('setTourStatus', true)
              this.$store.commit('setLearnStatus', true)
              this.$store.commit('setQuizStatus', true)
              this.$store.commit('course/setLastPlayedLevel', 0)
              this.$store.commit('course/setLevels', [])
              this.$store.commit('course/setGroups', [])
              this.$store.commit('course/setMemberId', 0)
              this.$store.commit('course/setExamStatus', -1)
              this.$store.commit('course/setBadgeScore', -1)
              this.$store.commit('course/setCourseLevelLoadedAfterLogin', false)
            } else {
              this.$store.commit('setNewUserLoggedin', false)
            }
          })
        }
      },
      clearUser () {
        this.$store.commit('user/setUserDetails', {})
        // Do Logout if user is not available
        document.cookie = 'user_name=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=cogneti.com'
        document.cookie = 'user_email=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=cogneti.com'
        document.cookie = 'auth_token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=cogneti.com'
      },
      tourOnStartCallback (currentStep) {
        this.currentStep = 0
        // console.log('currentStep', this.currentStep)
      },
      tourPreviousStepCallback (currentStep) {
        this.currentStep = this.currentStep - 1
        // console.log('currentStep', this.currentStep)
      },
      tourNextStepCallback (currentStep) {
        this.currentStep = this.currentStep + 1
        // console.log('currentStep', this.currentStep)
      },
      tourStopCallback (currentStep) {
        this.currentStep = -1
        // console.log('tourStopCallback, currentStep', this.currentStep)
        this.$store.commit('setTourStatus', false)
        this.$router.replace({ query: { tour: 'end' } })
        this.goToTop()
      },
      goToTop () {
        const element = document.getElementById('app')
        element.scrollIntoView()
        document.body.scrollTop = 0 // For Safari
        document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
      },
      getLayoutClass () {
        switch (this.$route.name) {
          case 'SignUp': return 'align-center'
          case 'Login': return 'align-center'
          case 'ForgotPassword': return 'align-center'
          case 'GetNameAndPwd': return 'align-center'
          case 'CodeVerification': return 'align-center'
          case 'ConfirmMyEmail': return 'align-center'
          default: return 'align-start'
        }
      },
      handleConnectivityChange (status) {
        // console.log('Online status:' + status)
        if (this.onlineStatus === true && status === true) {
          this.$store.commit('flashSuccess', 'You are now online.')
        }
        if (status === false) {
          this.$store.commit('flashError', 'It looks like you are offline! Trying to reconnect...')
          this.onlineStatus = true
        }
      },
      setFontLoaded () {
        this.fontLoaded = true
      },
      timeTracker () {
        const GAME_ID = process.env.GAME_ID
        // console.info('Time Tracking Started.', this.pageRoute, this.$route.name)
        const onTimeout = () => {
          this.sleepTime = Date.now()
          if (this.tracking) {
            console.info('time is up!')
            this.tracking = false
          }

          idleTimer.resetTimer()
        }
        const idleTimer = new IdleTimer(onTimeout, this.timeOut)

        idleTimer.activate()

        setInterval(() => {
          if (this.tracking &&
          ['learn', 'quiz'].includes(this.$route.name.toLowerCase()) &&
          (Date.now() > (this.sendDataTimestamp + this.sendDataTimeout + 2000))) {
            this.$http({
              url: `${this.apiUrl}/ws/tracking/time/user/${this.$store.getters['user/getUserDetails'].id}/course/${GAME_ID}`,
              method: 'POST',
              headers: {
                Authorization: 'Bearer ' + this.$auth.token()
              }
            })
            this.sendDataTimestamp = Date.now()
          }
          if (!this.tracking && (this.sleepTime + this.timeOut + 5000 < Date.now())) {
            console.info('Restart timer')
            this.tracking = true
          }
        }, 2000)
      }
    },
    watch: {
      allNewsDialog (val) {
        document.querySelector('html').classList.toggle('application--dialog-opened', val)
      },
      loadingCourseDialog (newVal) {
        if (this.$store.getters['getNewUserLoggedIn'] === true &&
          this.$store.getters['getTourStatus'] === true &&
          this.badgeScore <= 0 &&
          newVal === false) {
          setTimeout(() => {
            if (newVal === false) {
              this.$store.commit('setDashboardTourStart', new Date().getTime())
            }
          }, 500)
        }
        if (newVal === false && this.tourVal === 'start') {
          this.$store.commit('setDashboardTourStart', new Date().getTime())
        }
      },
      tourVal (newVal) {
        // using setTimeout because loadingCourseDialog is default false
        setTimeout(() => {
          if (this.loadingCourseDialog === false && newVal === 'start') {
            this.$store.commit('setDashboardTourStart', new Date().getTime())
          }
        }, 500)
      },
      currentStep (newVal) {
        this.$store.commit('setTourCurrentStep', newVal)
      },
      isDashboardTourStart (newVal) {
        if (newVal !== 0 &&
          newVal !== false &&
          this.$route.name === 'ProgramLevels') {
          this.$tours['dashboardTour'].start()
        } else {
          console.log('Stopping tour...')
          this.$tours['dashboardTour'].stop()
        }
      },
      badgeScore (newVal) {
        console.log('badgeScore changed')
        if (this.newVal > 0) {
          this.isDashboardTourStart = false
        }
      },
      async mobileStatusBarStatus (newVal) {
        if (newVal) {
          await StatusBar.show()
        } else {
          await StatusBar.hide()
        }
      },
      pageRoute (newVal) {
        if (['learn', 'quiz'].includes(newVal.toLowerCase())) {
          this.tracking = true
          this.timeTracker()
        } else {
          this.tracking = false
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import '~vuetify/src/stylus/main.styl';
  @import '~vuetify/src/stylus/app.styl';
  .snack-markdown
    font-size : 16px
    font-weight : 500

  div.application.font-not-loaded
    i.icon.material-icons
      visibility: hidden
      width: 0

  .sfh-games-logo
    border: 1px solid #5656dc
    border-radius: 3px
</style>
<style>
:root {
  --sat: env(safe-area-inset-top);
  --sar: env(safe-area-inset-right);
  --sab: env(safe-area-inset-bottom);
  --sal: env(safe-area-inset-left);
  --testVikas: 20px;
}

.footer-bg {
  background-image: url("/static/images/FooterBG.jpg");
  background-size: cover;
}
.bottom-menu {
  background: linear-gradient( rgba(105, 97, 255, 0.4) 100%, rgba(105, 97, 255, 0.5) 100%),url(/static/images/home_footer.jpeg)!important;
  background-repeat: no-repeat!important;
  background-size: cover!important;
  background-position-y: center!important;
  color: #ffffff;
}
.application {
  font-family: 'Nunito','Lato', sans-serif;
}
  .footer-copyright {
    background-color: #5A66B2;
  }
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: block; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 5; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}

.sfh-container {
  background-image: url("/static/images/gamepack-background.svg");
  height: 100%;
  background-position-x: center;
  background-position-y: center;
  background-size: 100%;
  padding: 0!important;
}
@media only screen and (max-width: 1024px) {
  .sfh-container {
    background-position-y: 100%;
    background-repeat-y: no-repeat;
    background-size: cover;
  }
}

.cogneti-logo {
  float: right;
  margin-top: 30px; position: absolute;right: 0;
  margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue